import { Icon } from '@george-labs.com/design-system';
import type { COLOR } from '@george-labs.com/design-system/types/utilsTS/color';

import { MainCategoryName } from '@shared/categories-utils';

export type Coloring = {
    foreground: COLOR;
    background: COLOR;
    normal: COLOR;
};

export type IconColoring = {
    foreground: COLOR;
    background: COLOR;
};

const { COLOR: Colors } = Icon;

const defaultColoring = getColoring(Colors.INDIGO_STRONG, Colors.INDIGO_WEAK, Colors.INDIGO);

export const coloringByCategory: Record<keyof typeof MainCategoryName, Coloring> = {
    [MainCategoryName.LIVING_AND_ENERGY]: getColoring(
        Colors.LILA_STRONG,
        Colors.LILA_WEAK,
        Colors.LILA,
    ),
    [MainCategoryName.FOOD]: getColoring(Colors.FOREST_STRONG, Colors.FOREST_WEAK, Colors.FOREST),
    [MainCategoryName.HEALTH]: getColoring(Colors.LIME_STRONG, Colors.LIME_WEAK, Colors.LIME),
    [MainCategoryName.CLOTHING]: getColoring(Colors.TEAL_STRONG, Colors.TEAL_WEAK, Colors.TEAL),
    [MainCategoryName.COMMUNICATION]: getColoring(
        Colors.BERRY_STRONG,
        Colors.BERRY_WEAK,
        Colors.BERRY,
    ),
    [MainCategoryName.LEISURE]: getColoring(
        Colors.LAVENDER_STRONG,
        Colors.LAVENDER_WEAK,
        Colors.LAVENDER,
    ),
    [MainCategoryName.EDUCATION]: getColoring(
        Colors.FOREST_STRONG,
        Colors.FOREST_WEAK,
        Colors.FOREST,
    ),
    [MainCategoryName.CAR]: getColoring(Colors.BERRY_STRONG, Colors.BERRY_WEAK, Colors.BERRY),
    [MainCategoryName.TRANSPORT]: getColoring(Colors.HONEY_STRONG, Colors.HONEY_WEAK, Colors.HONEY),
    [MainCategoryName.TRAVEL_HOLIDAYS]: getColoring(
        Colors.ROSE_STRONG,
        Colors.ROSE_WEAK,
        Colors.ROSE,
    ),
    [MainCategoryName.WITHDRAWAL]: getColoring(
        Colors.HONEY_STRONG,
        Colors.HONEY_WEAK,
        Colors.HONEY,
    ),
    [MainCategoryName.ALIMONY_POCKET_MONEY]: getColoring(
        Colors.POOL_STRONG,
        Colors.POOL_WEAK,
        Colors.POOL,
    ),
    [MainCategoryName.ONLINE_SHOPPING]: getColoring(
        Colors.POOL_STRONG,
        Colors.POOL_WEAK,
        Colors.POOL,
    ),
    [MainCategoryName.SAVINGS_INVESTMENT]: getColoring(
        Colors.LIME_STRONG,
        Colors.LIME_WEAK,
        Colors.LIME,
    ),
    [MainCategoryName.TAXES]: getColoring(Colors.FOREST_STRONG, Colors.FOREST_WEAK, Colors.FOREST),
    [MainCategoryName.FEES]: getColoring(Colors.CARROT_STRONG, Colors.CARROT_WEAK, Colors.CARROT),
    [MainCategoryName.OTHER_EXPENSES]: getColoring(
        Colors.ROSE_STRONG,
        Colors.ROSE_WEAK,
        Colors.ROSE,
    ),
    [MainCategoryName.UNCATEGORIZED_EXPENSE]: getColoring(
        Colors.STONE_STRONG,
        Colors.STONE_WEAK,
        Colors.STONE,
    ),
    [MainCategoryName.REGULAR_INCOME]: getColoring(
        Colors.LIME_STRONG,
        Colors.LIME_WEAK,
        Colors.LIME,
    ),
    [MainCategoryName.NON_REGULAR_INCOME]: getColoring(
        Colors.POOL_STRONG,
        Colors.POOL_WEAK,
        Colors.POOL,
    ),
    [MainCategoryName.UNCATEGORIZED_INCOME]: getColoring(
        Colors.STONE_STRONG,
        Colors.STONE_WEAK,
        Colors.STONE,
    ),
};

export function getIconColorByCategory(category?: string): Coloring {
    return coloringByCategory[category as keyof typeof coloringByCategory] ?? defaultColoring;
}

function getColoring(foreground: COLOR, background: COLOR, normal: COLOR): Coloring {
    return { foreground, background, normal };
}
